
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="任务名称" class="list-query-item ivu-col-span-12" >
                        <Input  v-model="queryParam.jobName" placeholder=""
                                @on-change="queryTableDatas" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table"  stripe border :height="tableHeight" class="tableList"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar'; //列表内操作
    import {trigger,pause,resume,remove } from "@api/quartz.js";
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList  ,CellBar},
        data() {
            return {
                serviceUrl:"/quartz/entity",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    jobName:"",
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '任务名称',
                        key: 'jobName',
                        width:"150"
                    },
                    {
                        title: '任务分组',
                        key: 'jobGroup',
                        width:"100"
                    },
                    {
                        title: '任务描述',
                        key: 'description',
                    },
                    {
                        title: '执行类',
                        key: 'jobClassName',
                    },
                    {
                        title: '执行时间',
                        key: 'cronExpression',
                        width:"200"
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            let editQuartzEntity = h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        icon:"md-create"
                                    },
                                    style: {
                                        marginRight: '5px',
                                        fontSize:"12px"
                                    },
                                    on: {
                                        click: () => {
                                            this.$nextTick(()=>{
                                                this.paasEditOper(params.row[this.currentIdFiledName]);
                                            })
                                        }
                                    }
                                }, '修改');
                            let removeQuartzEntity = h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    icon:"ios-trash"
                                },
                                style: {
                                    marginRight: '5px',
                                    fontSize:"12px"
                                },
                                on: {
                                    click: () => {
                                        this.$nextTick(()=>{
                                            this.removeTask(params.row[this.currentIdFiledName]);
                                        })
                                    }
                                }
                            }, '删除');
                            let triggerTask = h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    icon:"ios-play"
                                },
                                style: {
                                    marginRight: '5px',
                                    fontSize:"12px"
                                },
                                on: {
                                    click: () => {
                                        this.$nextTick(()=>{
                                            this.triggerTask(params.row[this.currentIdFiledName])
                                        })
                                    }
                                }
                            }, '执行');
                            let pauseTask = h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    icon:"ios-pause"
                                },
                                style: {
                                    marginRight: '5px',
                                    fontSize:"12px"
                                },
                                on: {
                                    click: () => {
                                        this.$nextTick(()=>{
                                            this.pauseTask(params.row[this.currentIdFiledName])
                                        })
                                    }
                                }
                            }, '停止');
                            let resumeTask = h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    icon:"md-refresh"
                                },
                                style: {
                                    marginRight: '5px',
                                    fontSize:"12px"
                                },
                                on: {
                                    click: () => {
                                        this.$nextTick(()=>{
                                            this.resumeTask(params.row[this.currentIdFiledName])
                                        })
                                    }
                                }
                            }, '恢复');
                            if(params.row.triggerState === "NORMAL"){
                                return h('div', [
                                    editQuartzEntity,
                                    removeQuartzEntity,
                                    triggerTask ,
                                    pauseTask
                                ]);
                            }else{
                                return h('div', [
                                    editQuartzEntity,
                                    removeQuartzEntity,
                                    triggerTask ,
                                    resumeTask
                                ]);
                            }


                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            /**
             * 触发任务
             * @param id
             */
            triggerTask(id){
                trigger(id).then(res=>{
                    this.$Message.info("触发任务成功");
                })
            },
            /**
             * 暂停任务
             * @param id
             */
            pauseTask(id){
                pause(id).then(res=>{
                    this.$Message.info("暂停任务成功");
                    this.queryTableDatas();
                })
            },
            /**
             * 恢复任务成功
             * @param id
             */
            resumeTask(id){
                resume(id).then(res=>{
                    this.$Message.info("恢复任务成功");
                    this.queryTableDatas();
                })
            },
            removeTask(id){
                remove(id).then(res => {
                    this.$Message.info("删除任务成功");
                    this.queryTableDatas();
                })
            }
        }
    }
</script>
<style scoped>
    .tableList >>> .ivu-table-cell .ivu-icon{
        font-size:12px;
    }
</style>
